import { IDropdownOption } from "@fluentui/react";

import { CarrierStatus, LineStatus, LineTypeEnum } from "./lines.interfaces";

export const lineStatusOptions: Array<IDropdownOption> = [
  { key: LineStatus.ACTIVE, text: "Ativa" },
  { key: LineStatus.RESERVED, text: "Reservada" },
  { key: LineStatus.IN_USE, text: "Em uso" },
  { key: LineStatus.SOLD, text: "Vendida" },
  { key: LineStatus.BACK_TO_CARRIER, text: "Devolvida para operadora" },
  { key: LineStatus.REMOVED, text: "Removida" }
];

export const carrierStatusOptions: Array<IDropdownOption> = [
  { key: CarrierStatus.ACTIVE, text: "Ativa" },
  { key: CarrierStatus.BLOCKED, text: "Bloqueada" },
  { key: CarrierStatus.SUSPENDED, text: "Suspensa" },
  { key: CarrierStatus.PROVISIONAL, text: "Provisória" },
  { key: CarrierStatus.MUREG, text: "MUREG" }
];

export const lineTypeOptions: Array<IDropdownOption> = [
  { key: LineTypeEnum.BRING_YOU_OWN, text: "Linha externa" },
  { key: LineTypeEnum.PRE, text: "Linha Pré" },
  { key: LineTypeEnum.VIRTUAL, text: "Linha Virtual" },
  { key: LineTypeEnum.REGULAR, text: "Linha Pós" }
];
